import { getConfig } from '@utils/config';
import { action, makeObservable, observable } from 'mobx';

export class ZendeskIframeManager {
  @observable
  open: boolean = false;

  static _instance: ZendeskIframeManager | undefined;

  static get shared(): ZendeskIframeManager {
    return (ZendeskIframeManager._instance ??= new ZendeskIframeManager());
  }

  constructor(private contentWindow?: Window, private navigateTo?: (path: string) => void) {
    makeObservable(this);
  }

  setContentWindow(v: Window) {
    this.contentWindow = v;
  }

  setNavigateToHandler(navigateTo: (path: string) => void) {
    this.navigateTo = navigateTo;
  }

  @action
  handleMessage(message: any) {
    switch (message.type) {
      case 'setOpen':
        this.open = message.value;
        return;
      case 'navigateTo':
        this.navigateTo?.(message.path);
        return;
    }
  }

  openTicketForD2dNo(v: string) {
    this.postMessage({
      type: 'navigateTo',
      path: `/open-ticket/${v}`,
    });
  }

  postMessage(message: any) {
    this.contentWindow!.postMessage(message, getConfig().d2dFrontendZendeskUrl);
  }
}
